import type { CSSProperties, StyleValue } from 'vue'

export type OverlayContentClass = string | string[] | undefined
export type OverlayMenuStyle = StyleValue | undefined
export type OverlayTokenStyles = CSSProperties & Record<`--${string}`, string | number>

export const appendOverlayContentClass = (
  contentClass: OverlayContentClass,
  className: string
): OverlayContentClass => {
  if (Array.isArray(contentClass)) {
    return contentClass.includes(className) ? contentClass : [...contentClass, className]
  }

  if (typeof contentClass === 'string') {
    const contentClassNames = contentClass.split(/\s+/)
    return contentClassNames.includes(className) ? contentClass : `${contentClass} ${className}`.trim()
  }

  return className
}

export const appendOverlayContentClasses = (
  contentClass: OverlayContentClass,
  classNames: string[]
): OverlayContentClass => {
  return classNames.reduce<OverlayContentClass>((nextContentClass, className) => {
    return appendOverlayContentClass(nextContentClass, className)
  }, contentClass)
}

export const mergeOverlayTokenStyles = (
  style: OverlayMenuStyle,
  tokenStyles: OverlayTokenStyles
): StyleValue => {
  if (!style) return tokenStyles
  return Array.isArray(style) ? [...style, tokenStyles] : [style, tokenStyles]
}
